import {envUtil} from '@/helper/env';

export function genSystemDevice() {
  if (envUtil.isApp) {
    const device = window.navigator.userAgent.split(' ')[1];
    if (device === 'iOS') {
      return 'IOS';
    }
    if (device === 'Android') {
      return 'ANDROID';
    }
  }
  return 'WEB';
}

export function versionToNum(appVersion) {
  return appVersion
    .toString()
    .split('.')
    .map((o, index) => Number(o) * Math.pow(10, (2 - index) * 2))
    .reduce((p, c) => p + c, 0);
}

export function getDevicePlatform() {
  const platform = genSystemDevice();
  if (platform === 'WEB' && envUtil.isMobile) {
    const isIOS = !!navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X| iOS /); // IOS终端
    return isIOS ? 'IOS-H5' : 'ANDROID-H5';
  }
  return platform;
}

export function genSystemDeviceForHttp() {
  if (envUtil.isApp) {
    const device = window.navigator.userAgent.split(' ')[1];
    if (device === 'iOS') {
      return 'IOS-H5';
    }
    if (device === 'Android') {
      return 'ANDROID-H5';
    }
  }
  // if (envUtil.isMobile) {
  //   return 'H5';
  // }
  return 'WEB';
}
